import React from 'react';
import { Spinner } from 'react-bootstrap';
import submitContact from '../models/contact';
import i18n from '../i18n';
import swal from 'sweetalert';
import './Contact.css'; // Import the CSS file

const HomeBanner = ({ callbackForSupport }) => (
  <div className="hero-banner">
    <div className="hero-content">
      <h1 className="hero-title">{i18n.t('contactus')}</h1>
      {/* <p className="hero-subtitle">Innovating for a Sustainable Future</p> */}
    </div>
  </div>
);
export class Contact extends React.Component {
  constructor() {
    super();
    this.state = {
      input: {},
      errors: {},
      is_submitted: false,
      is_progress: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitContact = this.submitContact.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });

    // Clear error when user starts typing
    if (this.state.errors[event.target.name]) {
      let errors = { ...this.state.errors };
      delete errors[event.target.name];
      this.setState({ errors });
    }
  }

  async submitContact() {
    let input = this.state.input;
    let errors = {};

    if (!input.first_name) {
      errors.first_name = 'First name is mandatory';
    }
    if (!input.last_name) {
      errors.last_name = 'Last name is mandatory';
    }
    if (!input.email) {
      errors.email = 'Your email is mandatory';
    }
    if (!input.contact_number) {
      errors.contact_number = 'Contact number is mandatory';
    }
    if (!input.message) {
      errors.message = 'Must include your query';
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ is_submitted: true });
    this.setState({ is_progress: true });

    try {
      const response = await submitContact(this.state.input);
      if (response.success) {
        swal(i18n.t('success'), 'Message sent successfully!!', 'success', {
          buttons: false,
          timer: 2000,
        })
          .then((value) => {
            this.resetForm();
          })
          .catch((response) => {
            swal('Failed', response.message, 'error');
          });
        this.setState({ is_progress: false });
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += '\n' + element;
          }
        }
        swal('Failed', error_message, 'error');
        this.setState({ is_submitted: false, is_progress: false });
      }
    } catch (error) {
      swal('Error', 'Something went wrong. Please try again.', 'error');
      this.setState({ is_submitted: false, is_progress: false });
    }
  }

  resetForm() {
    let input = {};
    input['first_name'] = '';
    input['last_name'] = '';
    input['email'] = '';
    input['contact_number'] = '';
    input['message'] = '';
    this.setState({ input: input, errors: {}, is_submitted: false, is_progress: false });
  }

  render() {
    return (
      <div className="page-container">
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />

        <div className="main-content">
          <div className="contact-section">
            <div className="container">
              <div className="contact-content">
                <div className="contact-form-section">
                  <div className="form-header">
                    <h2>{i18n.t('say_hello')}</h2>
                    <p>{i18n.t('say_hello2')}</p>
                    <p>{i18n.t('need_help')}</p>
                  </div>

                  <div className="contact-form">
                    <div className="form-row">
                      <div className="form-group">
                        <label>{i18n.t("first_name")}</label>
                        <input
                          type="text"
                          name="first_name"
                          value={this.state.input.first_name || ''}
                          onChange={this.handleChange}
                          placeholder={i18n.t('enter_firstname')}
                          className={this.state.errors.first_name ? 'error' : ''}
                        />
                        {this.state.errors.first_name && (
                          <span className="error-message">{this.state.errors.first_name}</span>
                        )}
                      </div>

                      <div className="form-group">
                        <label>{i18n.t('last_name')}</label>
                        <input
                          type="text"
                          name="last_name"
                          value={this.state.input.last_name || ''}
                          onChange={this.handleChange}
                          placeholder={i18n.t('enter_lastname')}
                          className={this.state.errors.last_name ? 'error' : ''}
                        />
                        {this.state.errors.last_name && (
                          <span className="error-message">{this.state.errors.last_name}</span>
                        )}
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>{i18n.t('email')}</label>
                        <input
                          type="email"
                          name="email"
                          value={this.state.input.email || ''}
                          onChange={this.handleChange}
                          placeholder={i18n.t('enter_email')}
                          className={this.state.errors.email ? 'error' : ''}
                        />
                        {this.state.errors.email && (
                          <span className="error-message">{this.state.errors.email}</span>
                        )}
                      </div>

                      <div className="form-group">
                        <label>{i18n.t('contact_number')}</label>
                        <div className="phone-input" dir="ltr">
                          <select className="country-code">
                            <option value="+966">+966</option>
                            <option value="+971">+971</option>
                            <option value="+968">+968</option>
                          </select>
                          <input
                            type="tel"
                            name="contact_number"
                            value={this.state.input.contact_number || ''}
                            onChange={this.handleChange}
                            placeholder={i18n.t('validate_phone')}
                            className={this.state.errors.contact_number ? 'error' : ''}
                          />
                        </div>
                        {this.state.errors.contact_number && (
                          <span className="error-message">{this.state.errors.contact_number}</span>
                        )}
                      </div>

                    </div>

                    <div className="form-group full-width">
                      <label>{i18n.t('message')}</label>
                      <textarea
                        name="message"
                        value={this.state.input.message || ''}
                        onChange={this.handleChange}
                        placeholder={i18n.t('validate_message')}
                        rows="5"
                        className={this.state.errors.message ? 'error' : ''}
                      ></textarea>
                      {this.state.errors.message && (
                        <span className="error-message">{this.state.errors.message}</span>
                      )}
                    </div>

                    <div className="submit-section">
                      {!this.state.is_progress ? (
                        <button
                          type="button"
                          className="btn btn-primary-custom flex-fill"
                          onClick={this.submitContact}
                        >
                          {i18n.t('send_message')}
                        </button>
                      ) : (
                        <div className="loading-container">
                          <Spinner animation="border" className="loading-spinner" />
                          <span>{i18n.t('sending_message')}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="contact-info-section">
                  <div className="contact-info-card">
                    <div className="info-header">
                      {/* <h3>Hi! We are always here to help you.</h3> */}
                    </div>

                    <div className="contact-methods">
                      <div className="contact-method">
                        <div className="contact-icon phone">
                          <i className="fa fa-compass" />
                        </div>
                        <div className="contact-details">
                          <span className="contact-label">{i18n.t('address')}</span>
                          <span className="contact-value">{i18n.t('ksa_full')}</span>
                        </div>
                      </div>

                      <div className="contact-method">
                        <div className="contact-icon whatsapp">
                          <i className="fa fa-whatsapp" />
                        </div>
                        <div className="contact-details">
                          <span className="contact-label">{i18n.t('call_us')}</span>
                          <a href="https://wa.me/+96892788822" dir="ltr" className="contact-value">+968 92 788 822</a>
                        </div>
                      </div>

                      <div className="contact-method">
                        <div className="contact-icon email">
                          <i class="fa fa-envelope" aria-hidden="true" />
                        </div>
                        <div className="contact-details">
                          <span className="contact-label">{i18n.t('email')}</span>
                          <a href="mailto:info@mzadcom.sa" className="contact-value">info@mzadcom.sa</a>
                        </div>
                      </div>
                    </div>

                    <div className="social-section">
                      <h4>{i18n.t('social_share')}</h4>
                      <div className="social-links">
                        <a href="https://www.facebook.com/profile.php?id=100074132232182" target="_blank" rel="noreferrer" className="social-link facebook">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                          </svg>
                        </a>
                        <a href="https://www.instagram.com/mzadcomsa" target="_blank" rel="noreferrer" className="social-link instagram">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>
                        </a>
                        <a href="#" className="social-link snapchat">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.404-5.957 1.404-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.744 2.856c-.269 1.051-1.03 2.632-1.492 3.434-.525-.16-1.045-.334-1.543-.525C18.13 21.399 22.021 17.365 22.021 12.435 22.021 5.696 17.383.029 12.017.029z" />
                          </svg>
                        </a>
                        <a href="#" className="social-link tiktok">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                          </svg>
                        </a>
                        <a href="https://twitter.com/mzadcom.sa" target="_blank" rel="noreferrer" className="social-link twitter">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1110.6794872709213!2d58.40878987751715!3d23.575830023909585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ffb71995cfc3%3A0x2af865eda725aadc!2sWorld%20Web%20IT%20Solutions%20L.L.C.%20(Webware)!5e0!3m2!1sen!2som!4v1757762355204!5m2!1sen!2som"
            width="100%"
            height=""
            style={{ height: '300px', padding: 0, margin: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="google-map"
            className="map-frame"
          ></iframe>
        </div>
      </div>
    );
  }
}